import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PortalManagementService = {
    getList: async ({ SearchText = "", page = 1, pageSize = 10, portal = "", IsAdminApproved = "" }) => {
        const params = new URLSearchParams({
            ...(SearchText && { SearchText }),
            ...(portal && { portal }),
            ...(IsAdminApproved && { IsAdminApproved }),
            page: page.toString(),
            pageSize: pageSize.toString(),
        });

        const response = await apiService.get(`/portal-access-requests?${params.toString()}`);
        return response.data;
    },

    approveUser: async (id, notes) => {
        const response = await apiService.put(`/portal-access-requests/${id}/approve`, { notes });
        return response.data;
    },

    unApproveUser: async (id, notes) => {
        const response = await apiService.put(`/portal-access-requests/${id}/reject`, { notes });
        return response.data;
    },

    getdetail: async (id) => {
        const response = await apiService.get(
            `/portal-user-activation/${id}`,
        );
        return response.data;
    },
    delete: async (id) => {
        const response = await apiService.delete(
            `/destinationcountrywidgets/harddelete/${id}`,
        );
        return response.data;
    },
    deleteMain: async (id) => {
        const response = await apiService.delete(
            `/destinationcountrywidgets/delete-main/${id}`,
        );
        return response.data;
    },
};

export default PortalManagementService;
